/* NEW: UI_REVAMP */ export const getTicketStatus = (status, isExpire) => {
	let statusText = 'Posted';
	let statusColor = '';

	if (status === 'Voided' || status === 'Denied') {
		statusText = status;
		statusColor = '#E52A2A';
	} else if (status === 'Striked') {
		statusText = 'Striked';
		statusColor = isExpire ? '' : 'green.500';
	} else if (status === 'Claimed') {
		statusText = 'Claimed';
		statusColor = 'blue.500';
	}

	return { statusText, statusColor };
};
